import type { PostTaskSchedulesRequestBody } from '@ulysses-inc/harami_api_client'
import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

export const queryKeys = {
  /** ひな形の選択肢（軽量一覧） */
  templates: [...queryKeyPrefix.taskSchedules, 'templates'],
  /** 現場ツリー（現場グループと配下の現場） */
  placeGroups: [...queryKeyPrefix.taskSchedules, 'placeGroups'],
  /** 試算。「試算する」を押した時点の body ごとに別のキーになる。押す前は null */
  simulation: (body: PostTaskSchedulesRequestBody | null) =>
    [...queryKeyPrefix.taskSchedules, 'simulation', body] as const,
}
